import React, { Component } from 'react';

import classnames from 'classnames';
import { WithStyles, withStyles } from '@mui/styles';

import APStepStyles from './styles/APStep.style';

interface APStepProps extends WithStyles<typeof APStepStyles> {
  label: string,
  state: 'active' | 'inactive' | 'complete',
  isResponsiveLabel: boolean
}

interface APStepState {
  isMobileView: boolean
}

class APStep extends Component<APStepProps, APStepState> {
  constructor(props: APStepProps) {
    super(props);
    this.state = {
      isMobileView: false
    }
  }

  handleResize = () => {
    const { isMobileView } = this.state;
    const { isResponsiveLabel } = this.props;
    let resizeTimer: ReturnType<typeof setTimeout>;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const showResponsiveLabel: boolean = window.innerWidth <= 422;

        if (isResponsiveLabel && isMobileView !== showResponsiveLabel) {
          this.setState({ isMobileView: showResponsiveLabel });
        }
      }, 500);
    });
  }

  componentDidMount(): void {
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => { });
  }

  render() {
    const {
      classes,
      label,
      state,
      isResponsiveLabel
    } = this.props;
    const { isMobileView } = this.state;

    window.addEventListener("resize", this.handleResize);

    const stepCls = classnames(classes.step, {
      [classes.stepActive]: state === 'active',
      [classes.stepComplete]: state === 'complete'
    });
    const stepLabel: string = isResponsiveLabel && isMobileView ? label.split(' ')?.[0] : label;

    return (
      <div className={stepCls}>
        <span className={'step-icon'}>
          <span className={'step-inner'}></span>
        </span>
        <span className={'step-label'}>{stepLabel}</span>
      </div>
    );
  }
}

export default withStyles(APStepStyles)(APStep);
